module.exports = __webpack_public_path__ + "media/components/Hero/triangle-5449ebf0b74f89976c387b4c0c58bd9d.svg";